import { Alert, AlertProps } from '@mui/material';
import React, { useState } from 'react';

type DismissableAlertProps = Omit<AlertProps, 'onClose' | 'action'> & {
  localStorageKey: string;
  content: React.ReactNode;
};

export const DismissableAlert = ({
  localStorageKey,
  content,
  ...props
}: DismissableAlertProps) => {
  const [shown, setShown] = useState(() => {
    const storedValue = localStorage.getItem(`alert-${localStorageKey}`);
    return storedValue !== 'false';
  });

  if (!shown) {
    return null;
  }

  return (
    <Alert
      variant="filled"
      sx={{ my: 1, ...props?.sx }}
      {...props}
      onClose={() => {
        localStorage.setItem(`alert-${localStorageKey}`, 'false');
        setShown(false);
      }}
    >
      {content}
    </Alert>
  );
};
